/* eslint-disable prettier/prettier */

import React,{createContext} from 'react';
import { Router } from 'react-router';
// import { History } from 'history';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const History = require('history');
import {
  RACThemeProvider, makeStyles, StylesProvider,
  createGenerateClassName,
} from '@rentacenter/racstrap';
import clsx from 'clsx';

import { ErrorBoundary } from '../components/ErrorBoundary/ErrorBoundary';
import { InContainerAuthProvider } from '../context/auth/InContainerAuthProvider';
import { StandaloneAuthProvider } from '../context/auth/StandaloneAuthProvider';
import { AuthGuard } from '../components/AuthGuard/AuthGuard';
import { CustomPropInterface } from '../../src/index';
// import '../components/InventoryTabs/Styles/commontheme.css';
// import '../components/InventoryTabs/Styles/Smart.css';
// import '../components/InventoryTabs/Styles/stylesheet.css';

interface Props {
  history: typeof History;
  customProps?: CustomPropInterface;
}

export const appTestId = 'appTestId';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
  },
}));

const generateClassName = createGenerateClassName({
  seed: 'RAC-INVENTORY-',
});
export const ContainerContext = createContext<CustomPropInterface | undefined>(
  undefined
);

export const App = ({ history,customProps }: Props) => {
  const { isRenderedByContainer } = window;
  const classes = useStyles();

  return (
    <div data-testid={appTestId}>
      <StylesProvider generateClassName={generateClassName}>
        <RACThemeProvider>
        <ContainerContext.Provider value={customProps}>
          <div className={clsx(classes.container)}>
            <ErrorBoundary>
              <Router history={history}>
                {isRenderedByContainer ? (
                  <InContainerAuthProvider>
                    <AuthGuard />
                  </InContainerAuthProvider>
                ) : (
                  <StandaloneAuthProvider>
                    <AuthGuard />
                  </StandaloneAuthProvider>
                )}
              </Router>
            </ErrorBoundary>
          </div>
          </ContainerContext.Provider>
        </RACThemeProvider>
      </StylesProvider>
    </div>
  );
};
